module.exports = __webpack_public_path__ + "img/03_L2.2a33da55.svg";